import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { DataTable, DialogAddCampus, Button, Can } from "../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    },
    titleCard: {
      textAlign: "center",
      width: "100%",
      margin: "16px 0"
    },
    actionsTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mt50: {
      marginTop: "50px"
    }
  };
});

var WebCampusList = function WebCampusList(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAddCampus = _useState2[0],
      setOpenAddCampus = _useState2[1];

  var classes = useStyles();

  var handleDialogAddCampus = function handleDialogAddCampus() {
    if (!openAddCampus) {
      props.handleDownloadProjects().then(function (x) {
        setOpenAddCampus(!openAddCampus);
      });
    } else {
      setOpenAddCampus(!openAddCampus);
    }
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(DialogAddCampus, {
    translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_campus || null : null : null,
    open: openAddCampus,
    onSubmit: props.handleSubmitAddCampus,
    projects: props.projects,
    onClose: handleDialogAddCampus
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, props.translation ? props.translation.title : "Campus")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2,
    className: classes.actionsTitle
  }, /*#__PURE__*/React.createElement(Can, {
    role: props.role,
    perform: "campus:add_campus",
    yes: function yes() {
      return /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: handleDialogAddCampus
      }, props.translation ? props.translation.buttons ? props.translation.buttons.add_campus : "Add campus" : "Add campus");
    },
    no: function no() {
      return null;
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.mt50
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, props.translation ? props.translation ? props.translation.texts ? props.translation.texts.users || "Users" : "Users" : "Users" : "Users"), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.titleCard
  }, props.campus.reduce(function (prev, current) {
    return prev + current.userCount;
  }, 0))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt50
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: props.campus,
    translation: props.translation ? props.translation.datatables ? props.translation.datatables.campus || null : null : null
  })));
};

export { WebCampusList };